// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1iElf","footer":"ModalCreateQualiphyProcedure_footer__5exRA","additionData":"ModalCreateQualiphyProcedure_additionData__3ZnvL"};